var url = "2e4b4e1da3a0e23c0f515d1eda7683a9.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;